export default __webpack_public_path__ + "static/media/gift.0762df83.svg";